const DO_LOGIN = 'DO_LOGIN';
const DO_LOGOUT = 'DO_LOGOUT';
const GET_USER_INFO = 'GET_USER_INFO';
const SET_USER_PERMS = 'SET_USER_PERMS';

/** ユーザー情報変更検出ハッシュ */
const AUTHORIZED_HASH = 'AUTHORIZED_HASH';

export default {
  DO_LOGIN,
  DO_LOGOUT,
  GET_USER_INFO,
  SET_USER_PERMS,
  AUTHORIZED_HASH,
};
